module.exports = __webpack_public_path__ + "static/1-32d2aeeedad6f28a9f6c0587a10ce3c1.png";